import React from 'react'
import './progressionForTypeTask.css'

const ProgressionForTypeTask = (props) => {
  const tasksCompleted = props.tasksCompleted
  const tasksDeferred = props.tasksDeferred
  const tasksTotal = props.tasksTotal
  const maxOfAllTotals = props.maxOfAllTotals

  const tasksToDo = tasksTotal - (tasksCompleted + tasksDeferred)
  const fillGap = maxOfAllTotals - tasksTotal

  return (
    <div className='progressionForTypeTask'>
      <div className='tasksCompleted' style={{ width: (tasksCompleted / maxOfAllTotals) * 100 + '%' }}></div>
      <div className='tasksDeferred' style={{ width: (tasksDeferred / maxOfAllTotals) * 100 + '%' }}></div>
      <div className='tasksToDo' style={{ width: (tasksToDo / maxOfAllTotals) * 100 + '%' }}></div>
      <div className='tasksDisplayTotal'>{tasksTotal > 0 ? tasksTotal : ''}</div>
    </div>
  )
}

export default ProgressionForTypeTask
